'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';

export default function StickyJoinBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 transition-all duration-300 ${visible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}
      style={{ background: '#141414', borderTop: '1px solid #2A2520' }}
    >
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div>
          <p className="text-sm font-500 text-white" style={{ fontWeight: 500 }}>Начни с $5 в месяц</p>
          <p className="text-xs" style={{ color: '#7A7470' }}>Отмена в любой момент · Без обязательств</p>
        </div>
        <div className="flex items-center gap-3">
          <Link
            href="/sign-up-login-screen"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-500 transition-all duration-200 active:scale-95"
            style={{ background: '#C9A96E', color: '#0A0A0A' }}
          >
            Выбрать тариф
            <ArrowRight size={13} />
          </Link>
          <Link
            href="/sign-up-login-screen"
            className="text-sm transition-colors"
            style={{ color: '#7A7470' }}
          >
            Войти
          </Link>
        </div>
      </div>
    </div>
  );
}